import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PoundCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/PoundCircleTwoTone";
import AntdIcon from "../components/AntdIcon";
var PoundCircleTwoTone = function PoundCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PoundCircleTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PoundCircleTwoTone.displayName = 'PoundCircleTwoTone';
}
export default /*#__PURE__*/React.forwardRef(PoundCircleTwoTone);